export const socketUrl = "https://chat.thriftshopnepal.com/"